import { render, staticRenderFns } from "./SurfacePostBeingShowed.vue?vue&type=template&id=fd65c4a4&scoped=true&"
import script from "./SurfacePostBeingShowed.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostBeingShowed.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostBeingShowed.vue?vue&type=style&index=0&id=fd65c4a4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd65c4a4",
  null
  
)

export default component.exports